import { UserOrganization } from '@modules-deprecated/app/organizations/types'
import { UserUmbrella } from '@modules-deprecated/app/umbrellas/types/userUmbrella'

import { OrganizationAvatar } from '../../OrganizationAvatar'
import { UmbrellaAvatar } from '../../UmbrellaAvatar'
import { DropDownHeaderAccessor } from '../enums/dropDownHeaderAccessor'
import { OrganizationItem } from '../types/organizationItem'

interface GetOrganizationsItemsProps {
  userOrganizations: UserOrganization[]
  userUmbrellas: UserUmbrella[]
}

export const getOrganizationsItems = ({ userUmbrellas, userOrganizations }: GetOrganizationsItemsProps) => {
  const umbrellaAccessorId = DropDownHeaderAccessor.Umbrella
  const organizationAccessorId = DropDownHeaderAccessor.Organization

  const umbrellasOrganizations =
    userUmbrellas?.map((umbrella): OrganizationItem => {
      const { umbrellaId, name, logoFileId } = umbrella

      return {
        id: umbrellaId,
        accessorGroupId: umbrellaAccessorId,
        children: name,
        iconLeft: <UmbrellaAvatar logoId={logoFileId} />,
        value: { umbrella },
        href: `/umbrellas/${umbrellaId}`,
      }
    }) ?? []

  const organizations =
    userOrganizations?.map((organization): OrganizationItem => {
      const { iconUrl, name, organizationId, url } = organization

      return {
        id: organizationId,
        accessorGroupId: organizationAccessorId,
        children: name,
        iconLeft: <OrganizationAvatar src={iconUrl} organizationId={organizationId} organizationName={name} />,
        value: { organization },
        href: `/${url}/`,
      }
    }) ?? []

  const sortedUmbrellas = [...umbrellasOrganizations].sort((a, b) => a.children.localeCompare(b.children))
  const sortedOrganizations = [...organizations].sort((a, b) => a.children.localeCompare(b.children))
  const organizationsItems = [...sortedUmbrellas, ...sortedOrganizations]

  return { organizationsItems }
}
